import axios from 'axios';

const { REACT_APP_BASE_URL } = process.env;

function getToken() {
  return localStorage.getItem('token');
}

async function getAppealRights() {
  return axios.get(REACT_APP_BASE_URL + `rest/v1/appeal-group`, { params: { token: getToken() } });
}

export const ToolbarRestApi = {
  getAppealRights,
};
